export function initVideoModals() {
   // Select all modals with the class 'video_modal'
   const videoModals = document.querySelectorAll('.video_modal');

   videoModals.forEach((modalElement) => {
      // Find the specific iframe inside this particular modal
      const iframeElement = modalElement.querySelector('iframe[data-src]');

      // Keep the player instance scoped to this specific modal's loop
      let vimeoPlayer = null;

      if (iframeElement) {
         // Event: Triggered when the play button is clicked and modal is about to show
         modalElement.addEventListener('show.bs.modal', () => {
            const videoSrc = iframeElement.getAttribute('data-src');

            // 1. Lazy Load: Only set the src if it hasn't been loaded yet
            if (!iframeElement.getAttribute('src')) {
               iframeElement.setAttribute('src', videoSrc);
            }

            // 2. Initialize the Vimeo Player API
            if (!vimeoPlayer && window.Vimeo) {
               vimeoPlayer = new window.Vimeo.Player(iframeElement);
            }

            // 3. Command playback
            if (vimeoPlayer) {
               vimeoPlayer.play().catch((error) => {
                  console.warn(
                     'Vimeo autoplay was prevented by the browser:',
                     error,
                  );
               });
            }
         });

         // Event: Triggered when the modal is closed
         modalElement.addEventListener('hide.bs.modal', () => {
            if (vimeoPlayer) {
               // Pause the video and reset the timeline to the beginning
               vimeoPlayer.pause();
               vimeoPlayer.setCurrentTime(0);
            } else {
               // Fallback: Remove the src entirely to forcefully stop playback if the API fails
               // Using removeAttribute ensures the lazy-load check works on the next open
               iframeElement.removeAttribute('src');
            }
         });
      }
   });
}
